import { TemplateElement, html, defineElement, when } from '@webtides/element-js';
import style from './lazy-iframe.css';
import IntersectionStore from '../../stores/intersection-store';

/**
 * @property {string} src
 * @property {'eager' | 'lazy'} loading
 * @property {string} sandbox
 * @property {string} allow
 * @property {string} referrerpolicy
 * @property {string} cssClasses
 * @property {string} height
 * @property {string} width
 * @property {IntersectionStore} intersectionStore
 */
export default class LazyIframe extends TemplateElement {
    constructor() {
        super({ styles: [style] });
    }

    properties() {
        return {
            src: '',
            loading: 'eager',
            sandbox: '',
            allow: '',
            referrerpolicy: '',
            height: '',
            width: '',
            cssClasses: '',
            intersectionStore: new IntersectionStore(),
        };
    }

    connected() {
        if (this.height) {
            this.style.height = this.height;
        }

        this.intersectionStore.observe(this);
    }

    disconnected() {
        this.intersectionStore.unobserve();
    }

    template() {
        return html`${when(
            this.src && this.intersectionStore.isIntersecting,
            html`
                <iframe
                    src="${this.src}"
                    allow="${this.allow}"
                    loading="${this.loading}"
                    sandbox="${this.sandbox}"
                    class="${this.cssClasses}"
                    referrerpolicy="${this.referrerpolicy}"
                    height="${this.height}"
                    width="${this.width}"
                ></iframe>
            `,
        )}`;
    }
}

defineElement('mb-lazy-iframe', LazyIframe);
